import React,{useState} from 'react'
import Header from 'components/Headers/Header';
import { Card,CardHeader,CardFooter,Media,Table,Container,Row,Button,Col,Modal, ModalHeader, ModalBody, ModalFooter, Input,Label, CardBody} from 'reactstrap'
import { payrollByDate, payEmployee } from 'network/ApiAxiosSchedule';
import { updatePayrate, updateContract } from 'network/ApiAxios';
//import { homepagee as homepage, apiRoot,ddns}  from "../../../package.json";
import {ddns} from '../../../../package.json'
import ToastComp from 'components/Reusable Components/ToastComp';

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import Report from '@weknow/react-data-report';
import PDFGenerator from './PDFGenerator';

function MainPayroll() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [interval, setinterval] = useState(15);
  const [shifts, setshifts] = useState();
  const [shiftsUnfiltered, setShiftsUnfiltered] = useState();
  const [payrateModalState, setPayrateModalState] = useState(false);
  const [contractModalState, setContractModalState] = useState(false);
  const [payrateUserId, setpayrateUserId] = useState(null);
  const [contractUserId, setContractUserId] = useState(null);
  const [payrateInput, setPayrateInput] = useState(0);
  const [contractInput, setContractInput] = useState(0);
  const [toast, setToast] = useState(false);
  const [hoursModalState, setHoursModalState] = useState(false);
  const [userHours, setUserHours] = useState(null);
  const [chkBox, setChkBox] = useState(false);
  const [roleSelect, setRoleSelect] = useState('All');
  const [totals, setTotals] = useState({
    workedHours:0,
    toPay:0
  });

  const togglePayrateModal = () => setPayrateModalState(!payrateModalState);
  const toggleContractModal = () => setContractModalState(!contractModalState);
  const toggleUserHoursModal = () => setHoursModalState(!hoursModalState);
  
  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const getPayroll = async()=>{
    if(startDate && endDate){
      const resp = await payrollByDate(startDate,endDate)
      if(resp.data.success){
        setshifts(resp.data.payroll.sort((a, b) => a.user.name.toUpperCase() < b.user.name.toUpperCase() ?  -1 :  1))
        setShiftsUnfiltered(resp.data.payroll.sort((a, b) => a.user.name.toUpperCase() < b.user.name.toUpperCase() ?  -1 :  1))
      }
    }
  }

  const payrateModal = (userId,name)=>{
    setpayrateUserId({userId:userId,name:name})
    togglePayrateModal()
  }

  const contractModal = (userId,name)=>{
    setContractUserId({userId:userId,name:name})
    toggleContractModal()
  }

  const savePayrate = async()=>{
    const resp = await updatePayrate(payrateUserId.userId,payrateInput)
    if(resp.data.success){
      togglePayrateModal()
      setPayrateInput(0)
      setToast({type:'green',tittle:'Payrate Saved',text:'Saved!!!'})
      getPayroll()
    }else{
      setToast({type:'red',tittle:'Payrate Save Failed',text:'Something went wrong please try again!!!'})
    }
  }

  const saveContract = async()=>{
    const resp = await updateContract(contractUserId.userId,contractInput)
    if(resp.data.success){
      toggleContractModal()
      setContractInput(0)
      setToast({type:'green',tittle:'Contract Pay Saved',text:'Saved!!!'})
      getPayroll()
    }else{
      setToast({type:'red',tittle:'Contract Save Failed',text:'Something went wrong please try again!!!'})
    }
  }

  const hoursModal = (user, hours,totals)=>{
    setUserHours({user:user, data:hours, totals:totals})
    toggleUserHoursModal()
  }

  const handlePay = async(userShifts)=>{
    let userAccomodation = userShifts.totals
    if(userAccomodation.rent != 0){
      userAccomodation = {
        rent : userAccomodation.rent,
        date: endDate,
        userId: userShifts.user._id
      }
    }else{
      userAccomodation = false
    }

    let userTotals = userShifts.totals
    userTotals.startDate = startDate
    userTotals.endDate = endDate
    userTotals.userId = userShifts.user._id

    const payUserId = userShifts.data[0].userId
    userShifts = userShifts.data.map((userShiftsItem)=>{
      return userShiftsItem._id
    })
    const resp = await payEmployee(userShifts,userAccomodation)
    
    if(resp.data.success){
      document.getElementById(payUserId).style.backgroundColor = 'lightgreen'
      document.getElementById('btn' + payUserId).disabled = true
    }
  }

  const handlePayAll = async(userShifts)=>{
    let userIds = []
    let shiftIds = []
    shifts.map((shiftItem)=>{
      shiftItem.data[0] && userIds.push(shiftItem.data[0].userId)
      shiftItem.data.map((shiftDataItem)=>{
        shiftIds.push(shiftDataItem._id)
      })
    })

    const resp = await payEmployee(shiftIds)

    if(resp.data.success){
      document.getElementById('shiftTable').style.backgroundColor = 'lightgreen'
    }
  }

  const tableRows = ()=>{
    return shifts.map((shiftItem,shiftIndex)=>{
      
      const userId = shiftItem._id
      /*
      setTotals({
        workedHours: totals.workedHours + shiftItem.totals.hoursWorked,
        toPay : totals.toPay + (shiftItem.totals.hoursWorked * shiftItem.user.payrate  - shiftItem.user.contract - shiftItem.totals.rent - shiftItem.totals.deposit)
      })
      */
      
      
        return <tr key={userId} id={userId} >
          <th scope="row">
            <img className="form-control-alternative mr-2" style={{ height: "50px" }} src={shiftItem.user.picture ? ddns + '/userfiles/' + shiftItem.user.email + '/pics/' + shiftItem.user.picture : null} />
            
            {shiftItem.user.name}
          </th>
          <td>
            <Button onClick={()=>hoursModal(shiftItem.user, shiftItem.data, shiftItem.totals)} className='ni ni-zoom-split-in mr-2'/>
            {shiftItem.totals.hoursWorked}
          </td>
          <td className={shiftItem.user.payrate == undefined ? 'bg-danger' : ''}>
            {shiftItem.user.payrate ? shiftItem.user.payrate : 0} €
            <Button onClick={()=>payrateModal(shiftItem.user._id,shiftItem.user.name)} className='ml-2 ni ni-settings-gear-65' />
          </td>
          <td className={shiftItem.user.contract == undefined ? 'bg-danger' : ''}>
            {console.log(shiftItem.user.contract)}
            {shiftItem.user.contract ? shiftItem.user.contract : 0} €
            <Button onClick={()=>contractModal(shiftItem.user._id,shiftItem.user.name)} className='ml-2 ni ni-settings-gear-65' />
          </td>
          <td>
            {shiftItem.totals.rent ? shiftItem.totals.rent : 0} €
          </td>
          <td>
            {shiftItem.totals.deposit ? shiftItem.totals.deposit + ' €' : '---'} 
          </td>
          <td>
            <Row>
            <Col>
              <label>Reason:</label>
              <input type='text' onChange={(e)=>{
                  let newShifts = shifts
                  newShifts[shiftIndex].totals.reason = e.target.value
                  setshifts(newShifts)
                }}/>
            </Col>
            <Col>
              <label>Amount</label>
              <input type='number'  onChange={(e)=>{
                  let newShifts = shifts
                  newShifts[shiftIndex].totals.deduction = Number(e.target.value) 
                  setshifts(newShifts)
                  
                  console.log(shifts)
                  //console.log(tableRows)
                  tableRows()
                }} />
            </Col>
            </Row>
          </td>
          <td>
            {shiftItem.totals.hoursWorked * shiftItem.user.payrate  - shiftItem.user.contract - shiftItem.totals.rent - shiftItem.totals.deposit - shiftItem.totals.deduction}
          </td>
          <td>
            <Button id={'btn' + shiftItem.user._id} onClick={()=>handlePay(shiftItem)} > Mark Payed</Button>
          </td>
        </tr>
      
    })
  }

  const handleChkBox = (e)=>{
    chkBox ? setChkBox(false) : setChkBox(true)
  }
    
  const handleRoleSelect = (e)=>{
    setRoleSelect(e.target.value)
  }

  const applyFilters = ()=>{
    let newArray = shiftsUnfiltered

    if(chkBox){
      newArray = newArray.filter((shiftItem)=>{
        return shiftItem.data.filter((userShiftItem)=>{
          return userShiftItem.payed != true
        }) != ''
      })
    }

    if(roleSelect != 'All'){
      newArray = newArray.filter((shiftItem)=>{
        return shiftItem.user.role == roleSelect
      })
    }
    setshifts(newArray)
  }

  const resetFilters = ()=>{
    setshifts(shiftsUnfiltered)
    setChkBox(false)
    setRoleSelect('All')
  }

  const pdfReport = ()=>{
    console.log(userHours)
    const formatedHours = userHours.data.map((hoursItem)=>{
      return {
        sTime:hoursItem.sTime ?
        new Date(Date.parse(new Date(hoursItem.sTime)) + 60*60*1000).toISOString()
        :'N.A.',
        ClockIn:hoursItem.ClockIn ?
        new Date(Date.parse(new Date(hoursItem.ClockIn)) + 60*60*1000).toISOString()
        :'N.A.', 
        eTime:hoursItem.eTime?
        new Date(Date.parse(new Date(hoursItem.eTime)) + 60*60*1000).toISOString()
        :'N.A.',
        ClockOut:hoursItem.ClockOut?
        new Date(Date.parse(new Date(hoursItem.ClockOut)) + 60*60*1000).toISOString()
        :'N.A.', 
        workedHours:hoursItem.workedHours?hoursItem.workedHours:'N.A.'
      }
    })
    formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Total Hours:', workedHours:userHours.totals.hoursWorked ? userHours.totals.hoursWorked : ''})
    formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Payrate:', workedHours:userHours.user.payrate ? userHours.user.payrate : ''})
    userHours.user.contract && formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Bank Transfer:', workedHours:userHours.user.contract ? userHours.user.contract : ''})
    userHours.totals.rent && formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Rent:', workedHours:userHours.totals.rent ? userHours.totals.rent : ''})
    userHours.totals.deduction && formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:userHours.totals.reason ? userHours.totals.reason : '', workedHours:userHours.totals.deduction ? userHours.totals.deduction : ''})
    formatedHours.push({sTime:'-',ClockIn:'-', eTime:'-',ClockOut:'Total:', workedHours:userHours.totals.hoursWorked * userHours.user.payrate - userHours.user.contract - userHours.totals.rent - userHours.totals.deduction })
    console.log(formatedHours)
    return <div style={{overflow:'auto'}}><Report data={ formatedHours} pageSize='a4' pageFormat={3} itemsPerPage={30} opening={(<h1>Clock IN/OUT Report {userHours.user.name}</h1>)}/></div>
      
  }

  const handlePicURL = (time)=>{
    console.log(time)
    time = new Date(time)
    return time.getDay() + '-' + (time.getMonth() + 1) + '-' + time.getFullYear() + 'at' + time.getHours() + 'H' + time.getMinutes()
  }

  return (
    <>
        <Header />
        {/* Page content */}
        <Container className="mt--2" fluid>
        <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                    <Row>
                        <h3 className='mt-3'>Date: </h3>
                        <DatePicker
                          onChange={onDateChange}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          withPortal
                          placeholderText="Select a date"
                          calendarStartDay={1}
                          className='ml-2 mt-3'
                        />
                        <Button className='ml-2' onClick={getPayroll} > Go</Button>
                      
                        {shifts && <PDFGenerator data={shifts} startDate={startDate} endDate={endDate}/>}
                      <hr/>
                    </Row>
                    <div hidden={shifts ? false : true}>
                      Filters:
                      <br/>

                        <Label check for="filterChkBox" className='ml-2 mt-2'>
                          Filter Out Payed
                        </Label>
                        <Input id="filterChkBox" name="check" value={chkBox} checked={chkBox} onChange={(e)=>handleChkBox(e)} type="checkbox" className='ml-3 mt-3' style={{transform:'scale(2)'}} />
                      
                      <Label for="exampleSelect" className='ml-5'> Select Role</Label>
                      <Input id="exampleSelect" name="select" className='ml-2' type="select" value={roleSelect} onChange={(e)=> handleRoleSelect(e)} >
                        <option value='All' >All</option>
                        <option value='admin' >Admin</option>
                        <option value='user' >User</option>
                        <option value='seller' >Seller</option>
                        <option value='cleaner' >Cleaner</option>
                        <option value='shop' >Shop</option>
                        <option value='manager' >Manager</option>
                        <option value='seller' >Seller</option>
                        <option value='managersellers' >Seller Manager</option>
                        <option value='security' >Security</option>
                      </Input>
                      <Button onClick={()=>applyFilters()} className='ml-2' >Apply Filters</Button>
                      <Button onClick={()=>resetFilters()} className='btn-danger ' >Reset Filters</Button>
                    </div>
                    
                </CardHeader>
                <CardBody>
                  <Table className="align-items-center table-flush" id='shiftTable' responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">HOURS</th>
                        <th scope="col">Pay Rate</th>
                        <th scope="col">Contract</th>
                        <th scope="col">Rent</th>
                        <th scope="col">Deposit</th>
                        <th scope="col">Deduction</th>
                        <th scope="col">Total</th>
                        <th scope="col">Pay</th>
                      </tr>
                    </thead>
                    <tbody>

                      {shifts ? tableRows() : null}

                    </tbody>
                  </Table>
                </CardBody>
                <CardFooter >
                  {/*<Button onClick={()=>handlePayAll()} className='float-right' >Mark All Payed</Button>*/}
                    Total Hours = {
                      shifts && shifts.reduce((partialSum, shiftItem) => partialSum + shiftItem.totals.hoursWorked, 0)
                    }
                    <br/>
                    <br/>Total to Pay = {
                      shifts && shifts.reduce((partialSum, shiftItem) => partialSum + shiftItem.totals.hoursWorked * shiftItem.user.payrate  - shiftItem.user.contract - shiftItem.totals.rent - shiftItem.totals.deposit - shiftItem.totals.deduction, 0)
                    }€
                    <br/>
                    <br/>Total Worked Hours - Penaltis = {/*totals.workedlate*/}€
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>

        {payrateModalState && <Modal isOpen={payrateModalState} toggle={togglePayrateModal}>
          <ModalHeader>
            Edit Pay Rate
              <p>{payrateUserId.name}</p>
          </ModalHeader>
          <ModalBody>
            <label className='mr-2'>Rate:</label>
            <input type='number' value={payrateInput} onChange={(e)=>setPayrateInput(e.target.value)} />
            <Button className='ml-4'onClick={()=>savePayrate()}>Save</Button>
          </ModalBody>
        </Modal>}

        {contractModalState && <Modal isOpen={contractModalState} toggle={toggleContractModal}>
          <ModalHeader>
            Edit Contract Pay
              <p>{contractUserId.name}</p>
          </ModalHeader>
          <ModalBody>
            <label className='mr-2'>Rate:</label>
            <input type='number' value={contractInput} onChange={(e)=>setContractInput(e.target.value)} />
            <Button className='ml-4'onClick={()=>saveContract()}>Save</Button>
          </ModalBody>
        </Modal>}

        {hoursModalState && <Modal isOpen={hoursModalState} toggle={toggleUserHoursModal} size='lg'>
          <ModalHeader>
            Clock IN/OUT
              <p>{userHours.user.name}</p>
          </ModalHeader>
          <ModalBody>
          <Table className="align-items-center table-flush"  responsive size='sm'> 
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Schedule IN</th>
                      <th scope="col">Clock IN</th>
                      <th scope="col">Schedule OUT</th>
                      <th scope="col">Clock OUT</th>
                      <th scope="col">Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userHours.data.map((hoursItem)=>{
                      return <tr key={hoursItem._id}>
                        <th scope='row'>
                          {hoursItem.sTime ? hoursItem.sTime.slice(0,-8) : 'N.A.'}
                        </th>
                        <td onClick={()=> window.open('https://celebrationjump.com/userfiles/_clockPics/clock-' + userHours.user._id + '-' + handlePicURL(hoursItem.ClockIn) + '.jpg', '_blank')}>
                          {hoursItem.ClockIn ? hoursItem.ClockIn.slice(0,-8) : 'N.A.'}
                        </td>
                        <td>
                          {hoursItem.eTime ? hoursItem.eTime.slice(0,-8) : 'N.A.'}
                        </td>
                        <td onClick={()=> window.open('https://celebrationjump.com/userfiles/_clockPics/clock-' + userHours.user._id + '-' + handlePicURL(hoursItem.ClockOut) + '.jpg', '_blank')}>
                          {hoursItem.ClockOut ? hoursItem.ClockOut.slice(0,-8) : 'N.A.'}
                        </td>
                        <td>
                          {hoursItem.workedHours}
                        </td>
                      </tr>
                    })}

                  </tbody>
                </Table>
                {       pdfReport()           }
          </ModalBody>
        </Modal>}

        {toast && <ToastComp type={toast.type} tittle={toast.tittle} text={toast.text} />}
    </>
  )
}

export default MainPayroll